import './DealerVendorListContent.scss'
import { DEALER_VENDOR_LIST_CONSTANT_CONSTANTS } from './DealerVendorListContentConstants';

const DealerVendorListContent = () =>{
    return (
        <div className='dealer-vendor'>
            <p>{DEALER_VENDOR_LIST_CONSTANT_CONSTANTS.TO_REGISTER} <a className='style-italic' href="mailto:Address.Book@Brightview.com" target='_blank' title='Mail to'>Address.Book@Brightview.com</a>
            </p>
            <p className='mt-2'>Click <a className='style-italic' href='https://inside.ourbrightview.com/Functions/AccountingFinance/AddressBook/Pages/default.aspx?tab=Documents' target='_blank' title='Vendor Setup Form'>HERE</a>  to download the Vendor Setup Form</p>
        </div>
    )
}

export default DealerVendorListContent;